export default __webpack_public_path__ + "static/media/WhiteRecommendation.dddb19e4.svg";